exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{overflow-y:auto}#app,body,html{min-height:100vh}#app{font-family:arlrdbd;text-align:center;background-color:#f3f3f3;display:flex;flex-direction:column}#form-container{padding-left:3vw;padding-right:3vw;margin-top:0;margin-bottom:3vh;flex:1}#form-container .column,#form-container .columns{margin-bottom:0}.is-divider{padding:0;margin-top:25px;margin-bottom:25px}.is-divider-vertical{padding:0;margin-right:20px;margin-left:20px}.title{margin-top:3.5vh;margin-bottom:3.5vh!important}.is-ancestor{height:100%}#columns-download a{width:100%}#button-download:hover{background-color:#2568d3}#button-download:active{background-color:#225ebd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ea52abfe","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 88
// module chunks = 0